import { PepInfoLabel } from '@namespace/account';
import { FORM_COMPONENTS_TYPES, FORM_VALIDATION_TYPES } from '@namespace/forms';

import styles from '../../index.module.css';

const useProfileFormFields = ({
  isInitPepChecked,
  isFetching,
  isCurrentPepChecked,
  pepOptions
}) => {
  const componentsList = [
    {
      type: FORM_COMPONENTS_TYPES.USER_COUNTRY_FIELD,
      label: 'personalOffice.profile.data.country',
      classNames: {
        className: styles.fieldWrap
      },
      disabled: true
    },
    {
      type: FORM_COMPONENTS_TYPES.INPUT_FIELD,
      name: 'city',
      label: 'personalOffice.profile.data.address',
      classNames: {
        wrapperClassName: styles.fieldWrap
      },
      disabled: true
    },
    {
      type: FORM_COMPONENTS_TYPES.INPUT_FIELD,
      name: 'address',
      classNames: {
        wrapperClassName: styles.secondFieldWrap
      },
      disabled: true
    },
    {
      type: FORM_COMPONENTS_TYPES.INPUT_FIELD,
      name: 'birthday',
      label: 'personalOffice.profile.data.birthday',
      classNames: {
        wrapperClassName: styles.fieldWrap
      },
      disabled: true
    },
    {
      type: FORM_COMPONENTS_TYPES.RADIO_GROUP,
      name: 'sex',
      elements: [
        {
          label: 'personalOffice.profile.data.male',
          value: 'mr',
          size: 'm',
          disabled: true
        },
        {
          label: 'personalOffice.profile.data.female',
          value: 'ms',
          size: 'm',
          disabled: true
        }
      ],
      classNames: {
        wrapperClassName: styles.radioGroupWrap
      }
    },
    {
      type: FORM_COMPONENTS_TYPES.HR_LINE,
      key: 'hr-line-1',
      className: `${styles.fieldWrap} ${styles.hr}`
    },
    {
      type: FORM_COMPONENTS_TYPES.CHECKBOX_FIELD,
      classNames: { wrapperClassName: `${styles.fieldWrap}` },
      className: styles.fieldWrap,
      name: 'pep',
      label: 'personalOffice.profile.data.publicFigure',
      size: 'm',
      disabled: isInitPepChecked
    },
    {
      type: FORM_COMPONENTS_TYPES.INFO_MESSAGE,
      key: 'field-info-message-2',
      label: <PepInfoLabel />,
      icon: 'info',
      classNames: {
        wrapperClassName: styles.fieldWrap
      }
    }
  ];

  if (isCurrentPepChecked) {
    const pepFields = [
      {
        type: FORM_COMPONENTS_TYPES.SELECT,
        name: 'pepGround',
        placeholder: 'personalOffice.profile.data.placeholder.pepGround',
        validationTypes: [FORM_VALIDATION_TYPES.REQUIRED],
        classNames: {
          containerClassName: styles.fieldWrap
        },
        options: pepOptions,
        disabled: isInitPepChecked
      },
      {
        type: FORM_COMPONENTS_TYPES.INPUT_FIELD,
        name: 'pepPosition',
        key: !isInitPepChecked
          ? 'pepPosition-available'
          : 'pepPosition-disabled',
        placeholder: 'personalOffice.profile.data.placeholder.pepPosition',
        validationTypes: [
          FORM_VALIDATION_TYPES.REQUIRED,
          {
            type: FORM_VALIDATION_TYPES.MAX_LENGTH_VALIDATOR,
            parameters: [256]
          }
        ],
        classNames: {
          wrapperClassName: styles.fieldWrap
        },
        disabled: isInitPepChecked
      }
    ];

    componentsList.push(...pepFields);
  }

  if (!isInitPepChecked) {
    componentsList.push({
      type: FORM_COMPONENTS_TYPES.SUBMIT_BUTTON,
      value: 'personalOffice.profile.data.save',
      classNames: {
        className: styles.saveBtn
      },
      disabled: isFetching
    });
  }

  return componentsList;
};

export default useProfileFormFields;
